import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // ✅ Ensure Swiper styles are imported
import "swiper/css/pagination"; // ✅ Import additional styles if needed
import PropTypes from "prop-types";
import Link from "next/link";

const Specializations = ({ specializations = [] }) => {
	return (
		<div>
			<Swiper slidesPerView={4} spaceBetween={10}>
				{specializations.map((specialization) => (
					<SwiperSlide prefetch={false} key={specialization._id} className="text-center gap-4">
						<SpecializationCard specialization={specialization} />
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

// ✅ Extracted SpecializationCard for cleaner structure
const SpecializationCard = ({ specialization }) => {
	return (
		<Link href={`/customer/lawyers?specializations=${specialization?._id}`}>
			<div>
				<Image
					src={specialization?.image}
					alt={specialization?.name?.ar}
					width={180}
					height={180}
					className="rounded-xl object-cover"
				/>
				<p>{specialization?.name?.ar}</p>
			</div>
		</Link>
	);
};

// ✅ PropTypes for type safety
Specializations.propTypes = {
	specializations: PropTypes.arrayOf(
		PropTypes.shape({
			_id: PropTypes.string.isRequired,
			image: PropTypes.string.isRequired,
			icon: PropTypes.string.isRequired,
			name: PropTypes.shape({
				ar: PropTypes.string.isRequired,
			}).isRequired,
		})
	),
};

SpecializationCard.propTypes = {
	specialization: PropTypes.shape({
		image: PropTypes.string.isRequired,
		icon: PropTypes.string.isRequired,
		name: PropTypes.shape({
			ar: PropTypes.string.isRequired,
		}).isRequired,
	}).isRequired,
};

export default Specializations;


export const SpecializationCardSkeleton = () => (
	<div className="text-center animate-pulse inline-block mx-2 md:mx-6">
		{/* Image Placeholder */}
		<div className="w-[180px] h-[180px] bg-gray-200 rounded-xl mx-auto"></div>
		{/* Text Placeholder */}
		<div className="h-4 bg-gray-200 rounded w-20 mx-auto mt-2"></div>
	</div>
);